<template>
  <base-panel
    v-show="dianJinList.length"
    :title="title"
    class="base-panel"
    @toMore="redirectAuthorPage(dianJinList[0].authorInfo.authorId)"
  >
    <ul class="dian-jins">
      <li
        v-for="item in dianJinList"
        :key="item.dianJinInfo.id"
        class="dian-jin"
      >
        <router-link
          class="dianjin-icon"
          :style="{ backgroundImage: `url(${item.dianJinInfo.coverImageUrl})` }"
          :to="`/dianjin/${item.dianJinInfo.id}`"
        >
          <div
            v-show="
                    item.dianJinInfo.type == 1
                  "
            class="dianjin-play-icon"
          ></div>
        </router-link>
        <div class="dianjin-right">
          <router-link class="name" :to="`/dianjin/${item.dianJinInfo.id}`">
            {{
            item.dianJinInfo.title.length > 5
            ? item.dianJinInfo.title.substring(0, 10) + '...'
            : item.dianJinInfo.title
            }}
          </router-link>
          <div class="date">{{ item.dianJinInfo.publishTimeDesc }}</div>
        </div>
      </li>
    </ul>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel/BasePanel'

export default {
  name: 'DianJinPanel',
  components: { BasePanel },
  props: {
    dianJinList: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    redirectAuthorPage(authorId) {
      this.$router.push({ path: '/author/' + authorId })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-panel {
  flex-direction: column;
  margin-top: 30px;
}
.dian-jins {
  padding: 15px 0;
}

.dian-jin {
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-left: 20px;
}

.dianjin-icon {
  width: 100px;
  height: 75px;
  position: relative;
  background: no-repeat center;
  background-size: cover;
  margin-right: 10px;
}
.dianjin-right {
  height: 75px;
  position: relative;
  display: flex;
  flex: auto;
}
.name {
  padding-top: 10px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
  text-decoration: none;
}

.date {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  position: absolute;
  color: #858585;
  bottom: 10px;
}
.dianjin-play-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 45px;
  top: 30px;
  background: url('~@/assets/images/dianjin/dianjin-list-icon.png') no-repeat
    center;
  background-size: contain;
}
</style>
